module.exports = __webpack_public_path__ + "static/img/icon-section-01.aa07a08c.png";